import * as React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as routes from "../../util/routes";
import Counter from "../../component/counter";

export default class ProjectionComponent extends React.Component {
  render() {
    return (
      <Switch>
        <Route
          path={routes.LOCAL_AUTHORITY_PATTERN + routes.PROJECTION_COUNTERS}
          render={(props) => <Counter {...props} />}
        />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/route/secured/projection.js